import { Outlet } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { useSessionBootstrap } from '@/hooks/useSessionBootstrap';
import { LocaleProvider } from '@/i18n/LocaleContext';
import { Toaster } from '@/components/ui/Toaster';

export default function Root() {
  useSessionBootstrap();
  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <Outlet />
        {/* Seguro em SSG: a lista nasce vazia e o componente não toca em window no render. */}
        <Toaster />
      </LocaleProvider>
    </QueryClientProvider>
  );
}
